import React from 'react';

interface LineCloseIconProps {
  size?: number;
  color?: string;
}

export const LineCloseIcon: React.FC<LineCloseIconProps> = ({ size = 24, color = '#686868' }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4 4L20 20" stroke={color} strokeWidth="2" strokeLinecap="round" />
      <path d="M20 4L4 20" stroke={color} strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
};
